module.exports = __webpack_public_path__ + "static/Baccara-c3a11d35aa51492a2999ed4f110e0b14.mp3";